/* eslint-disable no-param-reassign */
import { PayloadAction } from '@reduxjs/toolkit';
import { PermissionsState, PermissionsTabEnum } from '../permissions.slice';

export default function setTab(state: PermissionsState, action: PayloadAction<PermissionsTabEnum>): void {
  state.tab = action.payload;
}
